import { createClient, type SupabaseClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const key = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;
export const cloudConfigured = Boolean(url && key);
let client: SupabaseClient | null = cloudConfigured ? createClient(url!, key!, {
  auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true, flowType: 'pkce' },
}) : null;
export function getCloudClient(): SupabaseClient {
  if (!client) throw new Error('Cloud sharing is not configured. Local tracking is available.');
  return client;
}
/** Test-only injection; production always uses the public browser key. */
export function __setCloudClient(next: SupabaseClient | null) { client = next; }
